export default __webpack_public_path__ + "static/media/Aeonik-Bold.4ffb8d62.woff";